import {workplaceTypes} from "../types";
import {ModalContainerWarningRemovePhoto} from "../Modal/ModalContainerWarningRemovePhoto";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'
import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { VehicleNumberBlock } from "../Block/VehicleNumberBlock";
import {appNotification} from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';
import { flightMenuBlock } from '@/Block/FlightMenuBlock.js';

const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
    const byteCharacters = window.atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
}

function iphone(b64) {
    const contentType = 'image/png';
    var arrayOfStrings = b64.split(',');

    const blob = b64toBlob(arrayOfStrings[1], contentType);
    const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
}

export var TaskFlightGalleryPage = {
    controller: function () {
        var self = this;
        var im;

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        if (user.get('state.workplace') === workplaceTypes.driver) {
            this.topMenu = [
                { title: 'Задачи', url: '/vehicle/tasks', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];

            if (user.get('state.vehicleFreeTasksAvailable')) {
                this.topMenu.unshift(
                    { title: 'Свободные', url: '/vehicle/tasks/free', icon: 'fa-car' }
                )
            }
        } else if (user.get('state.workplace') === workplaceTypes.agent) {
            this.topMenu = [
                { title: 'Задачи', url: '/agent/tasks', icon: 'fa-tasks' },
                { title: 'Рейсы', url: '/agent/flights', icon: 'fa-plane' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        } else {
            this.topMenu = [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        }

        this.data = m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/gallery'
        }).then(function (response) {
            server.setOnline();
            loader.hide();
            storage.config = response.config;

            appNotification.list = response.notifications;

            server.initPing();
            appNotification.init();

            return response;
        }, function (response) {
            if (response && response.message) {
                self.errmsg = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });

    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: ctrl.data().time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", [
                VehicleNumberBlock(),
                m.component(flightMenuBlock, {
                    board: ctrl.data().board,
                    menu: ctrl.data().menu,
                    tasks: ctrl.data().tasks,
                    currentTask: ctrl.data().currentTask,
                    tab: 'info'
                })
            ]),
            m("div[style='padding: 0 15px; padding-top: 10px;']", [

                m("div.row[id='pictureConteiner'][style='width: 100%; height: auto; margin: 0']", [
                    ctrl.data().image.map(function (im) {
                        return m("div[style='display: flex; flex-direction: column; align-items: center; margin-top: 7px; outline: 1px solid #000;z-index:1;']",
                            {
                                id: im.dk
                            },
                            [
                                m("div", {
                                    className: "row bg-info",
                                    style: "padding:6px;padding-right: 11px;z-index:1; width: 100%;"
                                }, [
                                    m("span", {
                                        className: "pull-right",
                                        style: "cursor: pointer;z-index:1;",
                                        innerHTML: "<i class='glyphicon glyphicon-remove'>&nbsp;Удалить",
                                        onclick: function () {
                                            ModalContainerWarningRemovePhoto.open("Вы действительно хотите удалить фото?", false, true, im.dk);
                                        }
                                    })
                                ]),
                                m("img.col-xs-12 col-sm-6 col-md-4 col-xl img-thumbnail[src='" + iphone(im.base64) + "']"),
                                m("textarea[rows='3'][placeholder='Комментарий'][readOnly='true'][style='margin: 0px 7px; width: 100%;']", {
                                    value: im.comment != "" ? im.comment : ''
                                })
                            ]);
                    })
                ]),

                ModalContainerWarningRemovePhoto.init()
            ])

        ];
    }
};
